import React from 'react';
import pdf from './pdf2.svg';

const IconPdf = () => (
  <div>
    <img src={pdf} alt="pdf" height={22} />
  </div>
);

export default IconPdf;
